import React, { use, useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";
import CompanyDashboardWrapper from "components/lib/Shared/CompanyDashboardWrapper";
import TransactionChangesSignatureTab from "components/TransactionChangesSignatureTab";
import {
  getTransactionForChangesSignatureAsync,
  getTransactionUnderReviewAsync,
} from "state/slices/transaction";
import { getCompany } from "state/slices/company";
import { useSelector } from "react-redux";

const TransactionChangesSignature = () => {
  const { trxId, companyId } = useParams();
  const dispatch = useDispatch();
  const { transactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );
  const { officials } = transactionUnderReview.items;
  const [companyOfficials, setCompanyOfficials] = useState([]);

  useEffect(() => {
    if (officials?.length > 0) {
      setCompanyOfficials(officials);
    }
  }, [officials]);

  useEffect(() => {
    dispatch(
      getTransactionForChangesSignatureAsync({
        trxId,
      })
    );
    dispatch(
      getCompany({
        id: companyId,
        isDashboard: true,
      })
    );
  }, [trxId, companyId]);

  if (companyOfficials?.length > 0) {
    return (
      <div>
        <CompanyDashboardWrapper>
          <TransactionChangesSignatureTab />
        </CompanyDashboardWrapper>
      </div>
    );
  } else {
    return <div>loading...</div>;
  }
};

export default TransactionChangesSignature;
